// AuthContext.js
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const apiUrl = "http://localhost:5000";

export const LOCALSTORAGE_KEY_TOKEN = "token";

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState("");
  const [name, setName] = useState("");
  const [userType, setUserType] = useState("");
  const [token, setToken] = useState("");
  const [userName, setUserName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [provider, setProvider] = useState(null);
  const [signer, setSigner] = useState(null);
  const [chainId, setChainId] = useState(null);
  const [account, setAccount] = useState(null);
  const [apiUrl, setApiUrl] = useState("http://localhost:5000");

  /* WEB3 auth */

  /* WEB2 auth */

  useEffect(() => {
    const localStorageData = localStorage.getItem(LOCALSTORAGE_KEY_TOKEN);
    if (!localStorageData) return;

    const userData = JSON.parse(localStorageData);
    if (!userData) return;

    setIsLoggedIn(true);
    setName(userData.name);
    setUserType(userData.type);
    setToken(userData.token);
    setUserName(userData.username);
    setUserId(userData.id); // this should be a string already
  }, []);

  const login = (userData) => {
    console.log("USERDATA");
    setIsLoggedIn(true);
    setName(userData.name);
    setUserType(userData.type);
    setUserName(userData.username);
    setUserId(userData.id.toString());
  };

  const logout = () => {
    setIsLoading(false);
    setIsLoggedIn(false);
    setUserId("");
    setUserType("");
    setToken("");
    setUserName("");
    setName("");
    //removeCookie("token");
    localStorage.removeItem(LOCALSTORAGE_KEY_TOKEN);
    //window.location.href = "https://rankit.it/signin";
  };

  const value = useMemo(
    () => ({
      isLoggedIn,
      userId,
      userType,
      name,
      token,
      userName,
      login,
      logout,
      apiUrl,
    }),
    [isLoggedIn, userId, token, userName],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
